import { Container, styled } from "@mui/material";
import { Fragment, useEffect } from "react";
import { useParams } from "react-router";
import AnnouncementContainer from "../../components/announcement/announcement";
import PageTemplate from "../../components/template/page-template";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";
import NotFound from "../not-found";
import AvailableFields from "./components/available-fields";
import DetailsPane from "./components/details-pane";
import HistoricalSnapshots from "./components/historical-snapshots";
import ListDescription from "./components/list-description";
import StubbingRules from "./components/stubbing-rules";
import Sublists from "./components/sublists";
import { initListAction } from "./redux/list-page.actions";

const ListPage = ({ className }: IWithClassName) => {
    const listName = useAppSelector(
        ({ listPage }) => listPage.listDetails.details?.name,
    );
    const announcement = useAppSelector(
        ({ listPage }) => listPage.listDetails.details?.announcement,
    );
    const notFound = useAppSelector(
        ({ listPage }) => listPage.listDetails.notFound,
    );
    const { listId } = useParams();
    const numListId = listId ? parseInt(listId, 10) : 0;

    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(initListAction(numListId));
    }, [numListId]);

    return (
        <PageTemplate
            pageTitle={`RetailStat POI Data${listName ? ` - ${listName}` : ""}`}
            className={className}
        >
            <Container>
                {notFound ? (
                    <NotFound />
                ) : (
                    <Fragment>
                        {announcement && (
                            <AnnouncementContainer
                                announcements={[announcement]}
                                className="announcement-margin-bottom"
                            />
                        )}
                        <ListDescription />
                        <AvailableFields />
                        <DetailsPane />
                        <StubbingRules />
                        <Sublists />
                        <HistoricalSnapshots />
                    </Fragment>
                )}
            </Container>
        </PageTemplate>
    );
};

export default styled(ListPage)(({ theme }: IWithThemeProps) => ({
    ".announcement-margin-bottom": {
        marginBottom: theme?.spacing(7),
    },
}));
